import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import CredentialForm from './CredentialForm';
import CredentialList from './CredentialList';
import { Helmet } from 'react-helmet-async';

function ManageCredentialsByIssuer() {
  const [tabIndex, setTabIndex] = useState(0);
  const [showMoreDetails, setShowMoreDetails] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <Helmet>
        <title>Manage Credentials</title>
      </Helmet>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        textColor="primary"
        indicatorColor="primary"
        sx={{ ml: 4 }}
        TabIndicatorProps={{ sx: { width: 'auto' } }}
      >
        <Tab label="Manage Credentials" sx={{ minWidth: "auto", px: 2 }} />
        <Tab label="Create Credential" sx={{ minWidth: "auto", px: 2 }} />
      </Tabs>

      {tabIndex === 0 && (
        <Box p={3}>
          <CredentialList />
        </Box>
      )}

      {tabIndex === 1 && (
        <Box p={3}>
          <CredentialForm showMoreDetails={showMoreDetails} setShowMoreDetails={setShowMoreDetails} />
        </Box>
      )}
    </Box>
  );
}

export default ManageCredentialsByIssuer;
